/* ==========================================================================
   JS — all vanilla, no dependencies
   ========================================================================== */
(function(){
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $  = function(s,c){return (c||document).querySelector(s);};
  var $$ = function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));};
 
  var page = $('.hb-fountain-page');
  if(!page || page.getAttribute('data-hb-ready') === 'true') return;
  page.setAttribute('data-hb-ready', 'true');
  var formEndpoint = (page.getAttribute('data-form-endpoint') || '').trim();
  // Blank "Thank-you page path" in Customize = show the in-form success message instead of redirecting.
  var thankYouUrl  = (page.getAttribute('data-thank-you-url') || '').trim();
 
  /* ---------- 1. Header state + active nav link --------------------------- */
  var hdr = $('#siteHeader'), hero = $('.hero');
  function headerState(){
    var past = window.scrollY > (hero ? hero.offsetHeight - 90 : 80);
    hdr.classList.toggle('hdr--solid', past);
    hdr.classList.toggle('hdr--top', !past);
    var sticky = $('#stickyCta');
    if(sticky) sticky.classList.toggle('on', window.scrollY > 500);
  }
  headerState();
  window.addEventListener('scroll', headerState, {passive:true});
 
  var navLinks = $$('.nav a');
  var spy = 'IntersectionObserver' in window ? new IntersectionObserver(function(es){
    es.forEach(function(e){
      if(!e.isIntersecting) return;
      navLinks.forEach(function(a){
        a.classList.toggle('active', a.getAttribute('href') === '#' + e.target.id);
      });
    });
  }, {rootMargin:'-45% 0px -50% 0px'}) : null;
  ['fountains','materials','installations','customisation','process','faq']
    .forEach(function(id){ var el = document.getElementById(id); if(el && spy) spy.observe(el); });
 
  /* ---------- 2. Mobile drawer -------------------------------------------- */
  var burger = $('#burger'), drawer = $('#drawer');
  function setMenu(open){
    page.classList.toggle('is-menu-open', open);
    burger.setAttribute('aria-expanded', String(open));
    burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    drawer.setAttribute('aria-hidden', String(!open));
    document.body.style.overflow = open ? 'hidden' : '';
    if(open) hdr.classList.add('hdr--solid');
    else headerState();
  }
  burger.addEventListener('click', function(){ setMenu(!page.classList.contains('is-menu-open')); });
  $$('#drawer a').forEach(function(a){ a.addEventListener('click', function(){ setMenu(false); }); });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && page.classList.contains('is-menu-open')) { setMenu(false); burger.focus(); }
  });
 
  /* ---------- 3. Scroll reveal -------------------------------------------- */
  var revealItems = $$('.rv, .flowline, .proc__wrap', page);
  if(reduced || !('IntersectionObserver' in window)){
    revealItems.forEach(function(el){ el.classList.add('in'); });
  } else {
    var revealer = new IntersectionObserver(function(es, observer){
      es.forEach(function(e){
        if(e.isIntersecting){
          e.target.classList.add('in');
          observer.unobserve(e.target);
        }
      });
    }, {threshold:0.08, rootMargin:'0px 0px -5% 0px'});
    page.classList.add('hb-animate-ready');
    revealItems.forEach(function(el){ revealer.observe(el); });
    // Safety net: content can never remain as an empty frame.
    window.setTimeout(function(){
      revealItems.forEach(function(el){ el.classList.add('in'); });
    }, 1400);
  }
 
  /* ---------- 4. Button ripple origin ------------------------------------- */
  $$('.js-ripple').forEach(function(b){
    b.addEventListener('pointermove', function(e){
      var r = b.getBoundingClientRect();
      b.style.setProperty('--mx', ((e.clientX - r.left)/r.width*100) + '%');
      b.style.setProperty('--my', ((e.clientY - r.top)/r.height*100) + '%');
    });
  });
 
  /* ---------- 5. Reels — three independent vertical players ---------------- */
  var ICON_PLAY  = '<path d="M8 5v14l11-7z"/>';
  var ICON_PAUSE = '<path d="M7 5h3v14H7zM14 5h3v14h-3z"/>';
  var ICON_SOUND = '<path d="M11 5L6 9H3v6h3l5 4z"/><path d="M15.5 8.5a5 5 0 010 7"/>';
  var ICON_MUTE  = '<path d="M11 5L6 9H3v6h3l5 4z"/><path d="M16 9.5l4 5M20 9.5l-4 5"/>';
  var allReels = [];
 
  $$('.reel').forEach(function(reel){
    var vid    = $('video', reel);
    var ppIcon = $('.ppIcon', reel);
    var muteBtn = $('.js-mute', reel), muteIcon = $('.muteIcon', reel);
    if(!vid) return;
    allReels.push(vid);
 
    vid.muted = true;                                   // reels never start with sound
    muteIcon.innerHTML = ICON_MUTE;
 
    function play(){
      // only one reel at a time
      allReels.forEach(function(o){ if(o !== vid && !o.paused) o.pause(); });
      var p = vid.play();
      if(p && p.catch) p.catch(function(){ reel.classList.add('err'); });
      reel.classList.add('playing');
    }
    function toggle(){ if(vid.paused){ play(); } else { vid.pause(); } }
 
    $('.reel__play', reel).addEventListener('click', play);
    $('.js-pp', reel).addEventListener('click', toggle);
    vid.addEventListener('click', toggle);
 
    vid.addEventListener('play',  function(){ ppIcon.innerHTML = ICON_PAUSE; reel.classList.add('playing'); });
    vid.addEventListener('pause', function(){ ppIcon.innerHTML = ICON_PLAY; });
    vid.addEventListener('error', function(){ reel.classList.add('err'); reel.classList.remove('playing'); });
    var srcEl = $('source', vid);
    if(srcEl) srcEl.addEventListener('error', function(){ reel.classList.add('err'); reel.classList.remove('playing'); });
 
    muteBtn.addEventListener('click', function(){
      vid.muted = !vid.muted;
      muteIcon.innerHTML = vid.muted ? ICON_MUTE : ICON_SOUND;
      muteBtn.setAttribute('aria-pressed', String(vid.muted));
      muteBtn.setAttribute('aria-label', (vid.muted ? 'Unmute' : 'Mute') + ' this reel');
    });
 
    // pause when it leaves the viewport
    if('IntersectionObserver' in window) new IntersectionObserver(function(es){
      es.forEach(function(e){ if(!e.isIntersecting && !vid.paused) vid.pause(); });
    },{threshold:0.3}).observe(reel);
  });
 
  /* ---------- 5b. Lifestyle film (single 16:9) ----------------------------- */
  (function(){
    var stage = $('#lifeStage'), vid = $('#lifeVideo');
    if(!stage || !vid) return;
    var ppIcon = $('.ppIcon', stage), muteBtn = $('.js-mute', stage), muteIcon = $('.muteIcon', stage);
    vid.muted = true;
    muteIcon.innerHTML = ICON_MUTE;
 
    function play(){
      allReels.forEach(function(o){ if(!o.paused) o.pause(); });   // never two at once
      var p = vid.play();
      if(p && p.catch) p.catch(function(){ stage.classList.add('err'); });
      stage.classList.add('playing');
    }
    $('#lifePlay').addEventListener('click', play);
    $('.js-pp', stage).addEventListener('click', function(){ vid.paused ? play() : vid.pause(); });
    vid.addEventListener('click', function(){ vid.paused ? play() : vid.pause(); });
    vid.addEventListener('play',  function(){ ppIcon.innerHTML = ICON_PAUSE; stage.classList.add('playing'); });
    vid.addEventListener('pause', function(){ ppIcon.innerHTML = ICON_PLAY; });
    vid.addEventListener('error', function(){ stage.classList.add('err'); stage.classList.remove('playing'); });
    var src = $('source', vid);
    if(src) src.addEventListener('error', function(){ stage.classList.add('err'); stage.classList.remove('playing'); });
 
    muteBtn.addEventListener('click', function(){
      vid.muted = !vid.muted;
      muteIcon.innerHTML = vid.muted ? ICON_MUTE : ICON_SOUND;
      muteBtn.setAttribute('aria-pressed', String(vid.muted));
      muteBtn.setAttribute('aria-label', (vid.muted ? 'Unmute' : 'Mute') + ' the film');
    });
    if('IntersectionObserver' in window) new IntersectionObserver(function(es){
      es.forEach(function(e){ if(!e.isIntersecting && !vid.paused) vid.pause(); });
    },{threshold:0.25}).observe(stage);
  })();
 
  /* ---------- 6. Studio: all size/tier choices are visual only ------------- */
  // Studio state updates checkmarks and preview labels only. Never copy it into a lead.
  var CONFIG = [
    {key:'Size', label:'Overall Size'},
    {key:'Tiers', label:'Number of Tiers'}
  ];
  var choice = {};
  var optRoot = $('#optRoot');
  var pvChips = $('#previewChips');
  CONFIG.forEach(function(group, index){
    var selected = $('.chip[data-g="' + index + '"][aria-checked="true"]', optRoot);
    choice[group.key] = selected ? selected.dataset.v : '';
  });

  function renderPreview(){
    if(!pvChips) return;
    pvChips.textContent = '';
    ['Tiers', 'Size'].forEach(function(key){
      if(!choice[key]) return;
      var chip = document.createElement('span');
      chip.textContent = choice[key];
      pvChips.appendChild(chip);
    });
  }
  renderPreview();

  function selectChip(chip, focus){
    var gi = +chip.dataset.g;
    $$('.chip[data-g="'+gi+'"]', optRoot).forEach(function(c){
      c.setAttribute('aria-checked','false');
      c.tabIndex = -1;                       // roving tabindex: one stop per group
    });
    chip.setAttribute('aria-checked','true');
    chip.tabIndex = 0;
    if(focus) chip.focus();
    choice[CONFIG[gi].key] = chip.dataset.v;
    renderPreview();
  }
 
  optRoot.addEventListener('click', function(e){
    var chip = e.target.closest('.chip');
    if(chip) selectChip(chip, false);
  });
 
  optRoot.addEventListener('keydown', function(e){
    var chip = e.target.closest('.chip'); if(!chip) return;
    var dir = {ArrowRight:1, ArrowDown:1, ArrowLeft:-1, ArrowUp:-1}[e.key];
    if(!dir) return;
    e.preventDefault();
    var group = $$('.chip[data-g="'+chip.dataset.g+'"]', optRoot);
    var next  = group[(group.indexOf(chip) + dir + group.length) % group.length];
    selectChip(next, true);
  });
 
  /* ---------- 6b. Quote modal — same pattern as the reference file ----------
     The ONE .enq__card is moved into the dialog on open and handed back to
     the page on close. One form, one set of ids, one submit handler — so the
     popup and the on-page section can never get out of sync.               */
  var modal      = $('#quoteModal');
  var mSlot      = $('#modalSlot');
  var mSum       = $('#modalSummary');
  var enqCard    = $('.enq__card', page);
  var enqHome    = enqCard ? enqCard.parentNode : null;
  var inlineForm = $('#enqForm');
  var successBox = $('#enqSuccess');
  var modalReturn = null;
  var modalCloseTimer = null;
  var modalFocusTimer = null;
  var previousBodyOverflow = null;

  var inertedElements = [];
  function setDialogBackground(dialog, on){
    if(on){
      var node = dialog;
      while(node && node !== page && node.parentElement){
        Array.prototype.forEach.call(node.parentElement.children, function(sibling){
          if(sibling === node || sibling.tagName === 'SCRIPT' || sibling.tagName === 'STYLE') return;
          inertedElements.push({element:sibling, wasInert:sibling.hasAttribute('inert')});
          sibling.setAttribute('inert', '');
        });
        node = node.parentElement;
      }
    } else {
      inertedElements.forEach(function(item){
        if(!item.wasInert) item.element.removeAttribute('inert');
      });
      inertedElements = [];
    }
  }

  function lockPage(on, dialog){
    page.classList.toggle('is-dialog-open', on);
    setDialogBackground(dialog, on);
    if(on){
      if(previousBodyOverflow === null) previousBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    } else if(previousBodyOverflow !== null){
      document.body.style.overflow = previousBodyOverflow;
      previousBodyOverflow = null;
    }
  }

  function resetQuoteForm(){
    // Keep an unfinished enquiry, including its budget error, when the popup closes.
    if(!inlineForm || !inlineForm.classList.contains('sent')) return;
    inlineForm.reset();
    inlineForm.classList.remove('sent');
    if(successBox) successBox.classList.remove('on');
    $$('.f.invalid', inlineForm).forEach(function(x){ x.classList.remove('invalid'); });
    $$('.err', inlineForm).forEach(function(x){ x.textContent = ''; });
    $$('input, select, textarea', inlineForm).forEach(function(x){
      x.removeAttribute('aria-invalid');
      if(x.setCustomValidity) x.setCustomValidity('');
    });
    var st = $('[data-form-status]', inlineForm);
    if(st){ st.className = 'form-status'; st.textContent = ''; }
  }

  function focusQuote(){
    window.clearTimeout(modalFocusTimer);
    modalFocusTimer = window.setTimeout(function(){
      if(modal.hidden || modalCloseTimer !== null) return;
      var first = $('#fName', modal);
      var target = (first && !(inlineForm && inlineForm.classList.contains('sent')))
        ? first : $('.modal__close', modal);
      if(target) target.focus({preventScroll:true});
    }, 80);
  }

  function openQuote(source, trigger){
    if(!modal || !mSlot || !enqCard) return false;
    if(page.classList.contains('is-menu-open')) setMenu(false);
    if(inlineForm) inlineForm.dataset.ctaSource = source || 'popup';
    if(mSum) mSum.textContent = '';
    // Reopening during the closing transition must not move the card back home.
    if(modalCloseTimer !== null){
      window.clearTimeout(modalCloseTimer);
      modalCloseTimer = null;
    }
    if(!modal.hidden){
      modal.classList.add('on');
      focusQuote();
      return true;
    }

    modalReturn = trigger && trigger.closest('.drawer') ? burger : (trigger || document.activeElement);
    enqHome.style.minHeight = enqHome.offsetHeight + 'px';
    mSlot.appendChild(enqCard);
    enqCard.classList.add('in-modal', 'in');
    modal.hidden = false;
    lockPage(true, modal);
    requestAnimationFrame(function(){ requestAnimationFrame(function(){
      if(!modal.hidden && modalCloseTimer === null) modal.classList.add('on');
    }); });
    focusQuote();
    return true;
  }

  function closeQuote(){
    if(!modal || modal.hidden || modalCloseTimer !== null) return;
    window.clearTimeout(modalFocusTimer);
    modal.classList.remove('on');
    var finish = function(){
      modalCloseTimer = null;
      modal.hidden = true;
      resetQuoteForm();
      enqCard.classList.remove('in-modal');
      enqHome.appendChild(enqCard);
      enqHome.style.minHeight = '';
      if(inlineForm) delete inlineForm.dataset.ctaSource;
      lockPage(false);
      if(modalReturn && modalReturn.isConnected && modalReturn.getClientRects().length && modalReturn.focus){
        modalReturn.focus({preventScroll:true});
      }
    };
    if(reduced) finish(); else modalCloseTimer = window.setTimeout(finish, 300);
  }

  function ctaSource(trigger){
    if(trigger.id === 'specCta') return 'customisation-studio';
    if(trigger.id === 'processCta') return 'process';
    if(trigger.closest('.hdr')) return 'header';
    if(trigger.closest('.drawer')) return 'mobile-menu';
    if(trigger.closest('.hero')) return 'hero';
    if(trigger.closest('.stickycta')) return 'sticky-mobile';
    return 'page-cta';
  }
 
  if(modal){
    $$('[data-close]', modal).forEach(function(el){ el.addEventListener('click', closeQuote); });
    document.addEventListener('keydown', function(e){
      if(modal.hidden) return;
      if(e.key === 'Escape'){ e.preventDefault(); closeQuote(); }
      if(e.key === 'Tab'){                    // keep focus inside the dialog
        var f = $$('a[href], button, input, select, textarea', modal)
                  .filter(function(el){ return !el.disabled && el.getClientRects().length; });
        if(!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
        else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
      }
    });
  }
 
  /* CTA routing — every "#enquire" CTA opens the popup, like the reference ----- */
  document.addEventListener('click', function(e){
    var t = e.target.closest && e.target.closest('a[href="#enquire"]');
    if(!t || !page.contains(t)) return;
    if(!modal || !enqCard) return;             // no dialog on the page → normal anchor scroll
    e.preventDefault();
 
    // Every consultation button opens the same form without copying studio choices.
    openQuote(ctaSource(t), t);
  });
 
  /* ---------- 7. Gallery carousel + filters + lightbox --------------------- */
  var items = $$('.gitem');
  var track = $('#masonry'), dots = $('#cDots');
 
  function perView(){
    var live = items.filter(function(i){ return !i.classList.contains('hide'); });
    if(!live.length) return 1;
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    var w   = live[0].getBoundingClientRect().width + gap;
    return Math.max(1, Math.round((track.clientWidth + gap) / w));
  }
  function pageCount(){
    var live = items.filter(function(i){ return !i.classList.contains('hide'); });
    return Math.max(1, Math.ceil(live.length / perView()));
  }
  function currentPage(){
    var span = track.scrollWidth - track.clientWidth;
    if(span <= 1) return 0;
    return Math.round((track.scrollLeft / span) * (pageCount() - 1));
  }
  var MAX_DOTS = 6;
  function dotCount(){ return Math.min(pageCount(), MAX_DOTS); }
  function pageForDot(i){
    var n = pageCount(), d = dotCount();
    return d < 2 ? 0 : Math.round((i / (d - 1)) * (n - 1));
  }
  function dotForPage(p){
    var n = pageCount(), d = dotCount();
    return (n < 2 || d < 2) ? 0 : Math.round((p / (n - 1)) * (d - 1));
  }
  function buildDots(){
    var d = dotCount();
    dots.innerHTML = '';
    if(pageCount() < 2) return;
    for(var i = 0; i < d; i++){
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('role','tab');
      b.setAttribute('aria-label','Go to slide ' + (pageForDot(i) + 1));
      b.dataset.dot = i;
      dots.appendChild(b);
    }
    syncDots();
  }
  function syncDots(){
    var active = dotForPage(currentPage());
    $$('button', dots).forEach(function(b){
      b.setAttribute('aria-current', String(+b.dataset.dot === active));
    });
  }
  function goToPage(i){
    var n = pageCount();
    var span = track.scrollWidth - track.clientWidth;
    track.scrollTo({ left: (span * i) / Math.max(1, n - 1), behavior: reduced ? 'auto' : 'smooth' });
  }
  function step(dir){
    var n = pageCount(), cur = currentPage();
    var next = cur + dir;
    if(next < 0) next = n - 1;
    if(next > n - 1) next = 0;
    goToPage(next);
  }
 
  if(track && dots){
    buildDots();
    $('#cPrev').addEventListener('click', function(){ step(-1); });
    $('#cNext').addEventListener('click', function(){ step(1); });
    dots.addEventListener('click', function(e){
      var b = e.target.closest('button'); if(b) goToPage(pageForDot(+b.dataset.dot));
    });
    var st;
    track.addEventListener('scroll', function(){
      clearTimeout(st); st = setTimeout(syncDots, 90);
    }, {passive:true});
    track.addEventListener('keydown', function(e){
      if(e.key === 'ArrowRight'){ e.preventDefault(); step(1); }
      if(e.key === 'ArrowLeft'){ e.preventDefault(); step(-1); }
    });
    window.addEventListener('resize', function(){ clearTimeout(st); st = setTimeout(buildDots, 160); });
  }
 
  $$('.filters button').forEach(function(b){
    b.addEventListener('click', function(){
      $$('.filters button').forEach(function(x){ x.setAttribute('aria-selected','false'); });
      b.setAttribute('aria-selected','true');
      var f = b.dataset.filter;
      items.forEach(function(it){
        it.classList.toggle('hide', !(f === 'all' || it.dataset.cat === f));
      });
      track.scrollTo({ left: 0, behavior: 'auto' });
      buildDots();
    });
  });
 
  var lb = $('#lightbox'), lbImg = $('#lbImg'), lbCap = $('#lbCap'), lbCount = $('#lbCount');
  var idx = 0, lastFocus = null;
  function visible(){ return items.filter(function(i){ return !i.classList.contains('hide'); }); }
  function show(i){
    var list = visible(); if(!list.length) return;
    idx = (i + list.length) % list.length;
    var el   = list[idx];
    var img  = $('img', el);
    var cap  = $('figcaption', el);
    lbImg.src = img.src; lbImg.alt = img.alt;
    lbCap.innerHTML = cap ? cap.innerHTML : '';
    lbCount.textContent = (idx + 1) + ' / ' + list.length;
  }
  function openLb(el){
    lastFocus = el;
    var list = visible();
    show(list.indexOf(el));
    lb.classList.add('on');
    lockPage(true, lb);
    $('#lbClose').focus();
  }
  function closeLb(){
    lb.classList.remove('on');
    lockPage(false);
    if(lastFocus) lastFocus.focus();
  }
  items.forEach(function(it){
    it.addEventListener('click', function(){ openLb(it); });
    it.addEventListener('keydown', function(e){
      if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); openLb(it); }
    });
  });
  $('#lbClose').addEventListener('click', closeLb);
  $('#lbPrev').addEventListener('click', function(){ show(idx - 1); });
  $('#lbNext').addEventListener('click', function(){ show(idx + 1); });
  lb.addEventListener('click', function(e){ if(e.target === lb) closeLb(); });
  document.addEventListener('keydown', function(e){
    if(!lb.classList.contains('on')) return;
    if(e.key === 'Escape') closeLb();
    if(e.key === 'ArrowLeft')  show(idx - 1);
    if(e.key === 'ArrowRight') show(idx + 1);
    if(e.key === 'Tab'){
      var f = $$('button', lb);
      var first = f[0], last = f[f.length - 1];
      if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
    }
  });
  (function(){
    var x0 = null;
    lb.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; }, {passive:true});
    lb.addEventListener('touchend', function(e){
      if(x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if(Math.abs(dx) > 55) show(idx + (dx < 0 ? 1 : -1));
      x0 = null;
    }, {passive:true});
  })();
 
  /* ---------- 8. FAQ accordion (one open at a time) ------------------------ */
  var qs = $$('.acc__q');
  qs.forEach(function(q){
    q.addEventListener('click', function(){
      var open = q.getAttribute('aria-expanded') === 'true';
      qs.forEach(function(o){
        o.setAttribute('aria-expanded','false');
        var p = document.getElementById(o.getAttribute('aria-controls'));
        if(p) p.style.maxHeight = null;
      });
      if(!open){
        q.setAttribute('aria-expanded','true');
        var panel = document.getElementById(q.getAttribute('aria-controls'));
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });
  window.addEventListener('resize', function(){
    var openQ = qs.filter(function(q){ return q.getAttribute('aria-expanded') === 'true'; })[0];
    if(openQ){ var p = document.getElementById(openQ.getAttribute('aria-controls')); p.style.maxHeight = p.scrollHeight + 'px'; }
  });
 
  /* ---------- 9. Form validation + Google Sheets submission ------------ */
  // These are planned project budgets, not fountain price quotations.
  var ELIGIBLE_BUDGETS = {
    '50000_100000': true,
    '100000_300000': true,
    '300000_500000': true,
    '500000_plus': true
  };
  var BUDGET_MESSAGE = 'Our custom fountain consultation is currently available for projects with a planned budget of ₹50,000 or more.';

  function eligibleBudget(value){
    return Object.prototype.hasOwnProperty.call(ELIGIBLE_BUDGETS, value);
  }
  var RULES = {
    name:  {msg:'Please enter your name.',            test:function(v){ return v.trim().length > 1; }},
    phone: {msg:'Enter a valid 10-digit number.',     test:function(v){ return /^[6-9]\d{9}$/.test(v.trim()); }},
    email: {msg:'Enter a valid email address.',       test:function(v){ return /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(v.trim()); }},
    city:  {msg:'Please enter your city.',            test:function(v){ return v.trim().length > 1; }},
    place: {msg:'Select where it will be installed.', test:function(v){ return !!v; }},
    budget: {
      msg:function(v){
        return v === 'below_50000'
          ? (window.matchMedia('(max-width: 720px)').matches
              ? 'Consultations require a planned budget of ₹50,000 or more.' : BUDGET_MESSAGE)
          : 'Please select your planned project budget.';
      },
      test:eligibleBudget
    }
  };

  function ruleMessage(name, value){
    return typeof RULES[name].msg === 'function' ? RULES[name].msg(value) : RULES[name].msg;
  }

  function readUtm(){
    var keys = ['utm_source','utm_medium','utm_campaign','utm_term','utm_content'];
    var params = new URLSearchParams(window.location.search);
    var values = {}, hasCurrent = false;
    keys.forEach(function(key){
      values[key] = params.get(key) || '';
      if(values[key]) hasCurrent = true;
    });
    try {
      if(hasCurrent){
        window.sessionStorage.setItem('hbFountainUtm', JSON.stringify(values));
      } else {
        var stored = JSON.parse(window.sessionStorage.getItem('hbFountainUtm') || '{}');
        keys.forEach(function(key){ values[key] = stored[key] || ''; });
      }
    } catch(_error) {}
    return values;
  }
 
  /* Retain the existing text/plain, no-cors transport and 25-second timeout.
     The response is opaque: a resolved fetch cannot confirm a Sheet write.
     Budget enforcement/mapping in Apps Script is a separate deployment step. */
  function sendLead(payload){
    // Final browser-side guard immediately before any network request.
    if(!eligibleBudget(payload.budget_range) || payload.consent !== true){
      return Promise.reject(new Error('The enquiry does not meet the required form checks.'));
    }
    var controller = 'AbortController' in window ? new AbortController() : null;
    return new Promise(function(resolve, reject){
      var timer = window.setTimeout(function(){
        if(controller) controller.abort();
        var timeoutError = new Error('The request timed out.');
        timeoutError.name = 'AbortError';
        reject(timeoutError);
      }, 25000);
      window.fetch(formEndpoint, {
        method: 'POST',
        mode: 'no-cors',
        credentials: 'omit',
        headers: {'Content-Type':'text/plain;charset=utf-8'},
        body: JSON.stringify(payload),
        signal: controller ? controller.signal : undefined
      }).then(function(res){ window.clearTimeout(timer); resolve(res); },
              function(err){ window.clearTimeout(timer); reject(err); });
    });
  }
 
  function initForm(form){
    if(!form || form.dataset.hbFormReady === 'true') return;
    form.dataset.hbFormReady = 'true';
    var field  = function(n){ return form.querySelector('[name="' + n + '"]'); };
    var slot   = function(n){ return form.querySelector('[data-err="' + n + '"]'); };
    var status = $('[data-form-status]', form);
 
    function setStatus(kind, text){
      if(!status) return;
      status.className = 'form-status' + (kind ? ' is-' + kind : '');
      status.textContent = text || '';
    }
    function setErr(n, message){
      var el = field(n), box = el ? el.closest('.f') : null, sl = slot(n);
      if(box) box.classList.toggle('invalid', !!message);
      if(el){
        el.setAttribute('aria-invalid', message ? 'true' : 'false');
        if(el.setCustomValidity) el.setCustomValidity(message || '');
      }
      if(sl) sl.textContent = message || '';
    }
 
    var phone = field('phone');
    if(phone) phone.addEventListener('input', function(e){
      var digits = e.target.value.replace(/\D/g,'');
      if(digits.length > 10 && digits.indexOf('91') === 0) digits = digits.slice(2);
      if(digits.length > 10 && digits.charAt(0) === '0') digits = digits.slice(1);
      e.target.value = digits.slice(0,10);
    });
 
    Object.keys(RULES).forEach(function(n){
      var el = field(n); if(!el) return;
      el.addEventListener('blur', function(){
        setErr(n, RULES[n].test(el.value) ? '' : ruleMessage(n, el.value));
      });
      el.addEventListener('change', function(){
        setErr(n, RULES[n].test(el.value) ? '' : ruleMessage(n, el.value));
      });
    });
    var consentEl = field('consent');
    if(consentEl) consentEl.addEventListener('change', function(){
      if(consentEl.checked) setErr('consent', '');
    });
 
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      if(btn && btn.disabled) return;                  // no double submits
      var ok = true, firstBad = null;
 
      Object.keys(RULES).forEach(function(n){
        var el = field(n); if(!el) return;
        var good = RULES[n].test(el.value);
        setErr(n, good ? '' : ruleMessage(n, el.value));
        if(!good){ ok = false; firstBad = firstBad || el; }
      });
 
      var consent = field('consent');
      setErr('consent', consent && consent.checked ? '' : 'Please accept to continue.');
      if(!consent || !consent.checked){ ok = false; firstBad = firstBad || consent; }
 
      if(!ok){ setStatus('', ''); if(firstBad) firstBad.focus(); return; }
 
      if(!formEndpoint){
        setStatus('error', 'Form connection is not configured. Add the Apps Script /exec URL in Customize.');
        return;
      }
 
      var inPopup = !!form.closest('.in-modal');
      var utm = readUtm();
      var payload = {
        source_page: window.location.href.split('#')[0],
        form_location: inPopup ? 'popup' : 'inline',
        cta_source: form.dataset.ctaSource || (inPopup ? 'popup' : 'inline-form'),
        full_name: field('name').value.trim(),
        email: field('email').value.trim(),
        whatsapp_number: '+91' + field('phone').value.trim(),
        city: field('city').value.trim(),
        installation_location: field('place').value,
        budget_range: field('budget').value,
        requirements: field('message') ? field('message').value.trim() : '',
        consent: true,
        utm_source: utm.utm_source,
        utm_medium: utm.utm_medium,
        utm_campaign: utm.utm_campaign,
        utm_term: utm.utm_term,
        utm_content: utm.utm_content
      };
 
      var originalLabel = btn ? btn.innerHTML : '';
      if(btn){ btn.disabled = true; btn.textContent = 'Sending…'; }
      setStatus('info', 'Sending your enquiry…');
 
      sendLead(payload).then(function(){
        if(thankYouUrl){
          window.location.assign(thankYouUrl);
          return;
        }
        // No thank-you page configured → show the success panel in place (reference behaviour)
        if(btn){ btn.disabled = false; btn.innerHTML = originalLabel; }
        setStatus('', '');
        form.classList.add('sent');
        if(successBox){
          successBox.classList.add('on');
          successBox.focus({preventScroll:true});
          if(!inPopup) successBox.scrollIntoView({block:'center', behavior: reduced ? 'auto' : 'smooth'});
        }
      }).catch(function(error){
        if(btn){ btn.disabled = false; btn.innerHTML = originalLabel; }
        setStatus('error', error && error.name === 'AbortError'
          ? 'The request timed out. Please try again.'
          : 'We could not send your enquiry. Please check your connection or contact us on WhatsApp.');
      });
    });
    // Enable submission only after all validation handlers have been attached.
    var readyButton = form.querySelector('button[type="submit"]');
    if(readyButton) readyButton.disabled = false;
  }

  readUtm();
  initForm(inlineForm);
 
  /* ---------- 10. Misc ----------------------------------------------------- */
  var yr = $('#yr'); if(yr) yr.textContent = new Date().getFullYear();
 
  function syncHeaderH(){
    page.style.setProperty('--header-h', hdr.offsetHeight + 'px');
  }
  syncHeaderH();
  window.addEventListener('resize', syncHeaderH);
})();
/* End of complete hb-marble-fountain.js — 2026-10-17, clean spreadsheet payload. */
